import {
  Bar,
  BarChart,
  Cell,
  LabelList,
  XAxis,
  YAxis,
} from "recharts";
import { yAxisTickFormatter } from "../../../../../services/Utils/functionService";

const colors = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "red", "pink"];

const DeliveryTimes = ({ delivered, numberDocRequests }: any) => {
  const data = [
    { name: "Délivré", value: delivered?.totalDelivered },
    { name: "Avec -7 jours", value: delivered?.deliveredLessThan7Days },
    { name: "Avec +7 jours", value: delivered?.deliveredMoreThan7Days },
  ];

  return (
    <div className="flex justify-center items-center">
      <BarChart width={500} height={250} data={data} style={{ paddingTop: "10px" }}>
        <XAxis
          dataKey="name"
          tickFormatter={(value) => `${value}`}
          style={{ fontWeight: "100" }}
        />
        <YAxis
          domain={[0, numberDocRequests]}
          tickFormatter={yAxisTickFormatter}
          label={{
            value: "Nb de requêtes",
            angle: -90,
            position: "center",
            dx: -20,
            fontWeight: "100",
          }}
          style={{ fontWeight: "100" }}
        />
        <Bar dataKey="value" barSize={30}>
          <LabelList dataKey="value" position="top" />
          <Cell fill="#0077B3" key="Délivré" />
          <Cell fill="#93CC87" key="Dans -7 jours" />
          <Cell fill="#F2B33D" key="Dans +7 jours" />
        </Bar>
      </BarChart>
    </div>
  );
};

export default DeliveryTimes;
